import { render, staticRenderFns } from "./FlagtagEmpty.vue?vue&type=template&id=56735178&scoped=true&"
import script from "./FlagtagEmpty.vue?vue&type=script&lang=js&"
export * from "./FlagtagEmpty.vue?vue&type=script&lang=js&"
import style0 from "./FlagtagEmpty.vue?vue&type=style&index=0&id=56735178&lang=scss&scoped=true&"
import style1 from "./FlagtagEmpty.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56735178",
  null
  
)

export default component.exports